import InitApi from "api/InitApi";
import { useQuery } from "react-query";
import useAuthStore from "store/authStore";
import useTokenStore from "store/tokenStore";
import { fetchConfig } from "utils";

const useCountUserCartItems = () => {
	const { accessToken } = useTokenStore();
	const loggedIn = useAuthStore((state) => state.loggedIn);

	const fetch = async () => {
		if (!loggedIn) {
			return;
		}
		const instance = await InitApi({ accessToken });
		const res = await instance.get("carts/count");
		return res.data;
	};
	return useQuery("user_cart_count", () => fetch(), {
		...fetchConfig,
	});
};

export default useCountUserCartItems;
